module.exports = __webpack_public_path__ + "3bee48f7e2c54a4be94a6ecdb115fcf7.MP3";